import {Component, OnInit} from '@angular/core';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {AuthService} from '../../../../auth/auth.service';
import {Merchant} from '../../../../@services/gen';
import {MerchantService} from '../../../../pages/merchant/merchant.service';
import {Router} from '@angular/router';
import MerchantTypeEnum = Merchant.MerchantTypeEnum;
import {PageStateService} from '../../../services/page-state.service';

@Component({
  selector: 'app-dialog-merchant',
  templateUrl: './dialog-merchant.component.html',
  styleUrls: ['./dialog-merchant.component.scss'],
})
export class DialogMerchantComponent implements OnInit {
  selectedOption: number;
  options: Merchant[] = [];
  merchantTypeEnum;
  disableConfirm = true;
  isMerchantChose = false;

  constructor(
    private authService: AuthService,
    private merchantService: MerchantService,
    public dialogRef: MatDialogRef<DialogMerchantComponent>,
    private router: Router,
    private pageStateService: PageStateService
  ) {}

  ngOnInit(): void {
    this.merchantTypeEnum = MerchantTypeEnum;
    this.options = this.authService.getCurrentUser().merchants;

    if (this.options.length == 0) {
      this.authService.logout();
    }

    if (this.options.length > 0) {
      const hq = this.options.find((x) => x.merchantType === MerchantTypeEnum.HqMerchant);
      const subMerchant = this.options.filter((x) => x.merchantType !== MerchantTypeEnum.HqMerchant);

      this.options = [hq, ...subMerchant];

      this.disableConfirm = false;
      if (!this.merchantService.getCurrentMerchant()) {
        this.selectedOption = this.options[0].id;
        this.isMerchantChose = false;
      } else {
        this.selectedOption = this.merchantService.getCurrentMerchant().id;
        this.isMerchantChose = true;
      }
    }

    if (this.options.length == 1) {
      this.merchantService.setCurrentMerchant(this.options[0]).subscribe();
    }
  }

  onConfirmClick(): void {
    this.pageStateService.removeCurrentPageStateFromLocalStorage();

    const selectedMerchant = this.options.filter((x) => x.id == this.selectedOption);

    // Wait for merchant data to be fully saved before closing dialog
    this.merchantService.setCurrentMerchant(selectedMerchant[0]).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: () => {
        this.dialogRef.close(true); // Still close on error - fallback data saved
      }
    });
  }

  onCloseClick(): void {
    this.dialogRef.close(false);
  }

  onLogOutClick(): void {
    this.authService.logout().subscribe(() => {
      this.dialogRef.close(false);
      this.router.navigate(['/login']);
    });
  }

  selectOption(optionValue: number): void {
    this.selectedOption = optionValue;
  }
}
